export const RECURSO = 'RECURSO';
export const RECURSO_START = 'RECURSO_START';
export const RECURSO_SUCCESS = 'RECURSO_SUCCESS';
export const RECURSO_ERROR = 'RECURSO_ERROR';

export const RECURSO_ARQUIVOS = 'RECURSO_ARQUIVOS';
export const RECURSO_ARQUIVOS_START = 'RECURSO_ARQUIVOS_START';
export const RECURSO_ARQUIVOS_SUCCESS = 'RECURSO_ARQUIVOS_SUCCESS';
export const RECURSO_ARQUIVOS_ERROR = 'RECURSO_ARQUIVOS_ERROR';
